import SpriteSymbol from "../../../../mobile/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-star-rating",
  "use": "svg-icon-star-rating-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg-icon-star-rating\"><path d=\"M6 9.12097567L2.29179607 11 3 7.02016261 1.66533454e-16 4.20162612 4.14589803 3.62097567 6 0 7.85410197 3.62097567 12 4.20162612 9 7.02016261 9.70820393 11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol